import Swiper from "swiper";

class PropsBanner {
	constructor(element) {
		this.element = element;

		this.swiper = new Swiper(element, {
			spaceBetween: 20,
			slidesPerView: 1,
			centeredSlides: true,
			loop: true,
			allowTouchMove: true,
			autoplay: {
				delay: 5000,
			},
			observer: true,
			observeParents: true,
			breakpoints : {
				880: {
					slidesPerView: 4,
					spaceBetween: 100,
					autoplay: false,
					centeredSlides: false,
					allowTouchMove: false,
				}
			}
		});
	}
}

window.addEventListener("load", () => {
	(Array.from(document.querySelectorAll(".props-banner .swiper-container")) ?? [])
		.forEach((element) => new PropsBanner(element));
});
